import React, { Component } from 'react';
import { Spinner } from 'reactstrap';
import { connect } from 'react-redux';
import { SingletonSharedData } from '../../../js/singletonSharedData';
import { Singleton } from '../../../js/Singleton';
import {
	INTEGRATION,
	INTEGRATION_SUBACTION,
	USER_STATE,
	API_ENDPOINTS,
	DRAGGABLE_WINDOWS,
	SEARCH_OPTIONS,
	WORKBAR_ACTIONS,
	STEP_MANUAL_CALL,
	ALERT_CATALOG,
	ERROR_CATALOG,
	CUSTOM_CELLS,
	OUTBOUND_CAMP_TYPES,
	MANUAL_MESSAGES_STATUS,
	MANUAL_MESSAGES_STATUS_TAG
} from '../../../constants.js';
import { manualCall, messageApiRequest, onSendUnifiedResponse, messageApiRequestANIList, getRecordCallPermission } from '../../../redux/actions/A_messages_to_SM';
import { search, framesCamp, outBoundCall } from '../../../Images/Images';
import { arrowBack, starFav, btnClear } from '../../../Images/GenericSVG';
import { phoneIcon, ZtoA, AtoZ, manualCallSvg, cellICon, iconList } from '../../../Images/ManualCallSVG';
import whatsappIcon from '../../../Images/whatsapp-icono.svg';
import sendMessageIcon from '../../../Images/send-message.svg';
import { insertWindow, removeWindow } from "../../../redux/actions/A_draggable_windows_controller";
import { correctPhoneNumber, generalBody } from '../../../js/alertBodies';
import AlertWindow from '../Others/AlertWindow.jsx';
import { APIFactory } from 'cw-galatea-api-js/cw-galatea-api-js-bundle.js';
import Keyboard from '../Others/Keyboard.jsx';
import { CUSTOM_COMPONENTS } from '../../../js/customElements/customComponents';
import TableComponent from '../Others/TableComponent';
import SelectComponent from '../Others/SelectComponent';
import CallOutContainer from '../../Animations/CallOutContainer';
import { consultingApp, noConsultingApp } from '../../../redux/actions/A_reducer_consulting';
import AlertManualCallWindow from '../../Alerts/AlertManualCallWindow';
import { changeIsIntegration } from '../../../redux/actions/A_actions_Integration';
import SingletonWebSocket from '../../../js/Singletons/SingletonWebSocket';
import { Logger } from '../../../js/helpers/Logger.js';
import AlertModalActions from '../../../redux/actions/A_Alert_Modal';
import { alertQueryErrorBody } from '../../../js/alertQueryErrorBody';
import _ from 'lodash';
import TextareaAutosize from 'react-autosize-textarea/lib';
import { setMessageConvId, setMessageStatus } from '../../../redux/actions/A_manual_message';
import AlertManualMessageWindow from '../../Alerts/AlertManualMessageWindow';
import { MEDIATYPE } from 'cw-unified-inbox';
import { SingleTable } from '../Others/SingleTable';
import { templatesWhatsappWindow } from '../../../js/draggableComponents';

const MAX_LENGTH_MESSAGE = 4096;

const MANUAL_INPUTS = {
	PHONE_NUMBER: 'PHONE_NUMBER',
	MESSAGE_AREA: 'MESSAGE_AREA'
}	
class ManualCall extends Component {
	constructor(props) {
		super(props);
		this.language = new Singleton();
		this.sharedData = new SingletonSharedData();
		this.availableWAConnections = [
			this.language.getText('GUIManualMessageErrorserror-whatsapp-body1'),
			this.language.getText('GUIManualMessageErrorserror-whatsapp-body2')
		];
		this.lang = this.language.getLanguage() === '-1' ? this.sharedData.generalPermissions[27] : this.language.getLanguage();
		this.searchOptions = [
			{ text: this.language.getText('GUIManualCallsearchByName'), searchingBy: SEARCH_OPTIONS.BY_NAME },
			{ text: this.language.getText('GUIManualCallsearchByPhone'), searchingBy: SEARCH_OPTIONS.BY_PHONE }
		];

		this.searchOdbcOptions = [
			{ text: this.language.getText('GUIManualCallsearchByName'), searchingBy: SEARCH_OPTIONS.BY_NAME },
			{ text: this.language.getText('GUIManualCallsearchByPhone'), searchingBy: SEARCH_OPTIONS.BY_PHONE },
			{ text: this.language.getText('GUICallSpacecallkey'), searchingBy: SEARCH_OPTIONS.BY_CALL_KEY }
		];

		this.state = {
			campaingSelected: _.get(this.props.objProps.propsData, 'campaingName', ''),
			campaingID: _.get(this.props.objProps.propsData, 'campaingID', 0),
			phoneNumber: _.get(this.props.objProps.propsData, 'phoneNumber', this.sharedData.phoneNumber ? this.sharedData.phoneNumber : ''),
			disableManualCall: _.get(this.props.objProps.propsData, 'disableManualCall', false),
			isManualMessage: _.get(this.props.objProps, 'isManualMessage', false),
			campaingImage: '',
			correctPhoneNumberShowed: false,
			externalDBNotConfiguredShowed: false,
			campaingsShowed: false,
			ANIListShowed: false,
			callKey: '',
			data1: '',
			searchDataBase: '',
			searchCampaing: '',
			currentSearch: this.searchOptions[0],
			dbSearchShowed: false,
			campaingOrder: true,
			campaingList: [],
			contactList: [],
			recievedAlert: false,
			alertCode: 0,
			message: '',
			currentState: USER_STATE.AGENT_READY,
			shortNumber: false,
			InvalidCampaingAlert: false,
			CallValidationAlert: false,
			NoCampaignsFoundAlert: false,
			messageError: '',
			odbcMessageError: false,
			odbcGeneralError: false,
			isSpinnerOn: false,
			contactByODBC: false,
			searchEmpty: false,
			noCampaignSelected: false,
			showNoInputMessage:false,
			writeMessage: false,
			messageToSend: '',
			isInvalidNumber: true,
			showPhoneNumber: false,
			phoneNumberNoValid: false,
			aniSelected: '',
			searchANI: '',
			aniOrder: false,
			aniList: [],
			rotativeAniManualCall: 0,
			noANIListSelected: false,
			loadAni: false,
			templateWhatsapp: {},
			step: 0,
			templatesList: []
		};
		this.objectData = {
			UserID: this.sharedData.getParameters().UserID,
			CampID:  _.get(this.props.objProps.propsData, 'campaingID', 0),
			Ext: this.sharedData.getParameters().Extension,
			PhoneNumber: _.get(this.props.objProps.propsData, 'phoneNumber', ''),
			Name: '',
			CallOutChange: 0,
			Status: 0,
			CallKey: '',
			CallMode: 0
		};
		this.currentMessageError = null;
		this.ManualCallAlwaysShow = false;
		this.integration = false;
		this.step = STEP_MANUAL_CALL.FIRST_TRY;
		this.lastNumberTried = '';
		this.lastCampTried = '';
		this.validationsNumber = {
			[STEP_MANUAL_CALL.BLACKLIST_OR_WRONG_CAMP]: () => this.campHasChanged(),
			[STEP_MANUAL_CALL.INCORRECT_NUMBER]: () => this.numberHasChanged()
		};

		this.alertCatalog = {
			[ALERT_CATALOG.TIME_ZONE]: () => {
				var data = { number: this.state.phoneNumber };
				SingletonWebSocket.send(SingletonWebSocket.getJson(INTEGRATION.MANUAL_CALL, INTEGRATION_SUBACTION.TIME_ZONE_NUMBER_EVENT, data));
				this.setTimerCallAlert();
			},
			[ALERT_CATALOG.NO_CAMPAINS]: () => {
				this.setTimerCallAlert();
			},
			[ALERT_CATALOG.CHECK_NUMBER]: () => {
				this.setState({ shortNumber: true });
				let _this = this;
				_this.canRequestCall = true;
				setTimeout(function () {
					_this.setState({ shortNumber: false });
				}, 5000);
				this.step = STEP_MANUAL_CALL.BLACKLIST_OR_WRONG_CAMP;
				let integrationMessage = { client: 'galatea', action: 'ManualCall', subaction: 'wrongNumber', data: this.state.phoneNumber };
				SingletonWebSocket.send(integrationMessage);
			},
			[ALERT_CATALOG.INCORRECT_NUMBER]: message => this.incorrectNumber(message)
		};

		this.erorCatalog = {
			[ERROR_CATALOG.ON_BLACKLIST]: message => {
				this.blackListNumber(message);
				this.sendErrorToIntegration(message);
			},
			[ERROR_CATALOG.NO_LONG_DISTANCE]: message => {
				this.sendErrorToIntegration(message);
				this.setTimerCallAlert();
			},
			[ERROR_CATALOG.NO_LOCAL_CALLS]: message => {
				this.sendErrorToIntegration(message);
				this.setTimerCallAlert();
			},
			[ERROR_CATALOG.NO_CELLPHONE]: message => {
				this.step = STEP_MANUAL_CALL.BLACKLIST_OR_WRONG_CAMP;
				this.sendErrorToIntegration(message);
				this.setTimerCallAlert();
			},
			[ERROR_CATALOG.USER_OUT_CAMP]: message => {
				this.setTimerCallAlert();
				this.sendErrorToIntegration(message);
			},
			[ERROR_CATALOG.NO_CAMPAIGN]: () => {
				this.setState({ InvalidCampaingAlert: true });
				this.setTimerCallAlert();
			},
			[ERROR_CATALOG.UNABLE_VERIFY_PHONE_NUMBER]: () => {
				let integrationMessage = { client: 'galatea', action: 'ManualCall', subaction: 'wrongNumber', data: this.state.phoneNumber };
				SingletonWebSocket.send(integrationMessage);
				this.setTimerCallAlert();
			},
			[ERROR_CATALOG.NO_PORTS_ASSIGNED]: message => {
				this.sendErrorToIntegration(message);
				this.setTimerCallAlert();
			}
		};
		this.messagesCalatog = { ALERT: this.alertCatalog, ERROR: this.erorCatalog };

		let APIFact = new APIFactory();
		this.apiCont = APIFact.buildClient();
		this.canRequestCall = true;
		this.userHangout = false;
		this.OdbcValue = parseInt(this.sharedData.getGeneralPermissions()[239], 10);
		this.externalParameters = { name: SEARCH_OPTIONS.BY_NAME, phone: SEARCH_OPTIONS.BY_PHONE };
		this.externalOdbcParameters = { name: SEARCH_OPTIONS.BY_NAME, phone: SEARCH_OPTIONS.BY_PHONE, callKey: SEARCH_OPTIONS.BY_CALL_KEY };
		this.customCell = CUSTOM_CELLS.BY_NAME;
		this.textArea = React.createRef();
	}
	setTimerCallAlert() {
		let _this = this;
		this.setState({ CallValidationAlert: true });
		setTimeout(function () {
			_this.setState({ CallValidationAlert: false });
		}, 5000);
	}
	sendErrorToIntegration(message) {
		const json = message.Json;
		const type = json.Type;
		const code = json.InternalCode;
		const error = this.language.getText(`${type.toLowerCase()}-${code}`);
		const integrationMessage = { client: 'galatea', data: { code, message: error }, action: 'errorOnDialProcess' };
		SingletonWebSocket.send(integrationMessage);
	}
	//VALIDATIONS FOR STEP NUMBER
	campHasChanged() {
		if (this.state.campaingID !== this.lastCampTried) {
			this.step = 0;
		}
	}
	numberHasChanged() {
		if (this.state.phoneNumber !== this.lastNumberTried && this.state.phoneNumber !== this.state.fixedPhoneNumber) {
			this.step = 0;
		}
	}
	componentWillReceiveProps(nextProps) {
		if (nextProps.userState.currentState !== this.state.currentState) {
			this.setState({ currentState: nextProps.userState.currentState });
		}
		if (nextProps.objProps.propsAlert) {
			this.setState({
				recievedAlert: true,
				alertCode: nextProps.objProps.propsAlert.alertCode,
				message: nextProps.objProps.propsAlert.message
			});
		}
		let dragComponent = nextProps.dragWindowController.dragComponent;

		if (dragComponent && dragComponent.idComponent === DRAGGABLE_WINDOWS.MANUAL_CALL) {
			this.setState({
				campaingSelected: dragComponent.componentProps ? dragComponent.componentProps.campaingName : this.state.campaingSelected,
				campaingID: dragComponent.componentProps ? dragComponent.componentProps.campaingID : this.state.campaingID,
				phoneNumber: dragComponent.componentProps ? dragComponent.componentProps.phoneNumber : this.state.phoneNumber
			});
			this.ManualCallAlwaysShow = dragComponent.componentProps ? dragComponent.componentProps.ManualCallAlwaysShow : this.ManualCallAlwaysShow;
			if (this.ManualCallAlwaysShow) {
				this.sharedData.setPhoneNumber(dragComponent.componentProps.phoneNumber);
				this.sharedData.setCampaingID(dragComponent.componentProps.campaingID);
				this.props.messageApiRequest(API_ENDPOINTS.CALL_OUT_CAMPAIGNS, '', true);
				Logger.Trace(`[Manual Call][ManualCallAlwaysShow] ObjProps:  ${dragComponent.componentProps}`);
				var data = {
					CamId: dragComponent.componentProps.campaingID,
					CallKey: this.state.callKey,
					Phone: dragComponent.componentProps.phoneNumber,
					Data: this.state.data1,
					ExistsCallout: 0,
					CallMode: 0,
					ani: this.state.aniSelected
				};
				this.props.manualCall(data);
				this.ManualCallAlwaysShow = false;
			}
		}

		if (nextProps.otherActions.workBarUpdate === WORKBAR_ACTIONS.MANUAL_CALL && this.state.campaingList.length === 0) {
			const newObject = {};
			for(let key in this.sharedData.callOutCampaigns){
				const whatsCondition = this.state.isManualMessage ? this.sharedData.callOutCampaigns[key].Camptype === OUTBOUND_CAMP_TYPES.WHATSAPP : this.sharedData.callOutCampaigns[key].Camptype !== OUTBOUND_CAMP_TYPES.WHATSAPP;
				if(whatsCondition){
					newObject[key] = this.sharedData.callOutCampaigns[key];
				}
			}
			this.setCampaingObj(newObject);
		}
		if (this.sharedData.callOutCampaigns && this.sharedData.getIsIntegration()) {
			let integrationMessage = { client: 'galatea', data: this.sharedData.callOutCampaigns, action: 'onCampaigns' };
			SingletonWebSocket.send(integrationMessage);
			this.sharedData.setIsIntegration();
		}
		if (nextProps.messagesIntegrations !== this.props.messagesIntegrations) {
			if (nextProps.messagesIntegrations.dataMessageIntegration && nextProps.messagesIntegrations.dataMessageIntegration.action === INTEGRATION.MANUAL_CALL) {
				this.sharedData.setIsIntegrationManualCall();
				this.setState({
					campaingID: nextProps.messagesIntegrations.dataMessageIntegration.camId,
					phoneNumber: nextProps.messagesIntegrations.dataMessageIntegration.phoneNumber,
					callKey: nextProps.messagesIntegrations.dataMessageIntegration.callKey,
					data1: nextProps.messagesIntegrations.dataMessageIntegration.clientName,
					recievedAlert: false
				});
			}
		}

		if (nextProps.userState.currentState === USER_STATE.DIALOG) {
			this.setState({ phoneNumber: '', data1: '', callKey: '' });
		}
	}
	componentDidUpdate(prevProps, prevState) {
		if (this.sharedData.getIsIntegrationManualCall()) {
			this.sharedData.setIsIntegrationManualCall();
			var data = {
				CamId: this.state.campaingID,
				CallKey: this.state.callKey,
				Phone: this.state.phoneNumber,
				Data: this.state.data1,
				ExistsCallout: 0,
				CallMode: 0
			};
			this.integration = true;
			this.sharedData.setPhoneNumber(data.Phone);
			this.requestCall();
		}

		if(this.props.manualMessageStatus === MANUAL_MESSAGES_STATUS.SEND && this.props.manualMessageStatus !== this.props.prevManualMessageStatus && prevProps.manualMessageConvId === this.props.manualMessageConvId && this.props.manualMessagePhone === undefined){
			setTimeout(() => {
				this.props.removeWindow(DRAGGABLE_WINDOWS.MANUAL_MESSAGE);
			}, 200)
			setTimeout(() => {
				this.props.onSetMessageStatus(MANUAL_MESSAGES_STATUS.SEND, undefined);
			}, 300)
		}

		if(this.state.phoneNumber !== prevState.phoneNumber && this.state.phoneNumber && this.state.isManualMessage){
			this.cleanPhoneNumber();
		}

		if(this.state.writeMessage && this.state.writeMessage !== prevState.writeMessage){
			setTimeout(()=>{
				this.textArea.focus();
			}, 200)
		}
		if (this.sharedData.aniList.length > 0 && this.state.aniList !== this.sharedData.aniList) {
			this.setState({ loadAni: false, aniList: this.sharedData.aniList });
		}
	}

	cleanPhoneNumber = () => {
		const newPhone = this.state.phoneNumber.replace(/\D/g, '');
		this.setState({phoneNumber: newPhone});
	}

	componentDidMount() {
		this.keyboard = this.refs['Keyboard'];
		this.props.messageApiRequest(API_ENDPOINTS.CALL_OUT_CAMPAIGNS, '', true);
		this.keyboard.focusTel();
		if (this.props.objProps.propsData) {
			Logger.Trace(`[Manual Call][componentDidMount] ObjProps:  ${this.props.objProps.propsData}`);
			if (this.props.objProps.propsData.action === INTEGRATION.MANUAL_CALL) {
				this.setState({
					campaingID: this.props.objProps.propsData.callData.campaingID,
					phoneNumber: this.props.objProps.propsData.callData.phoneNumber,
					callKey: this.props.objProps.propsData.callData.callKey,
					data1: this.props.objProps.propsData.callData.data1,
					recievedAlert: this.props.objProps.propsData.callData.recievedAlert
				});
				this.sharedData.setIsIntegrationManualCall();
			} else {
				let data = {
					UserID: this.sharedData.getParameters().UserID,
					CampID: this.state.campaingID,
					Ext: this.sharedData.getParameters().Extension,
					PhoneNumber: this.state.phoneNumber,
					Name: this.state.data1,
					CallOutChange: 0,
					Status: this.step,
					CallKey: this.state.callKey,
					CallMode: 0,
					integration: this.integration
				};

				this.sharedData.setPhoneNumber(data.Phone);
				if(this.props.objProps.propsData.rotativeAniManualCall === 1){
					this.setState({rotativeAniManualCall: this.props.objProps.propsData.rotativeAniManualCall})
					this.props.messageApiRequestANIList(API_ENDPOINTS.SELECT_ANI_MANUAL_CALL, this.state.campaingID, true);
				}
				else{
					this.validatePhoneNumber(data);
				}
			}
		}
		this.sharedData.setStateWindow(DRAGGABLE_WINDOWS.MANUAL_CALL, true);
		this.sharedData.setFocusTel(false);
	}
	componentWillUnmount() {
		this.sharedData.setCallOutCampaigns('');
		this.sharedData.setStateWindow(DRAGGABLE_WINDOWS.MANUAL_CALL, false);
	}
	setCampaingObj(campaingList) {
		if (typeof campaingList === 'undefined' && (this.props.objProps.propsData === null || this.props.objProps.propsData.campaingID === 0)) {
			this.setState({ NoCampaignsFoundAlert: true });
		} else {
			this.setState({ NoCampaignsFoundAlert: false });
		}
		var campList = [];
		for (var i in campaingList) {
			var campaing = campaingList[i];
			campaing.isFav = false;
			campaing.imgCampaing = framesCamp[campaing.GraphicID];
			campaing.starFav = starFav;
			campList.push(campaing);
			if (campaing.Default) {
				this.selectCampaing(campaing);
			}
		}
		if (this.state.campaingList.length === 0) {
			this.setState({ campaingList: campList });
			this.props.noConsultingApp();
		}
	}
	selectCampaing(campaing) {
		this.setState({
			campaingsShowed: false,
			campaingSelected: campaing.Description,
			campaingID: campaing.ID,
			campaingImage: campaing.imgCampaing,
			campaingManualMode: campaing.CampManualMode,
			rotativeAniManualCall: campaing.SelectRotativeAniManualCall,
			ANIListShowed: false,
			loadAni: true,
			aniSelected: '',
			aniList: []
		});
		this.sharedData.setANIListCampaign([]);
		this.props.messageApiRequestANIList(API_ENDPOINTS.SELECT_ANI_MANUAL_CALL, campaing.ID, true);

		setTimeout(() => {
			this.props.getRecordCallPermission(API_ENDPOINTS.GET_RECORD_CALL_PERMISSION, campaing.ID, true);
		}, 500);	
	}
	favCampaing(evt, campaing) {
		var campaings = this.state.campaingList;
		let camp = campaings.filter(x => {
			return x.ID === campaing.ID;
		})[0];
		camp.isFav = !camp.isFav;
		this.setState({ campaingList: campaings });
		evt.stopPropagation();
	}
	selectContact(item) {
		this.setState({
			phoneNumber: item[SEARCH_OPTIONS.BY_PHONE],
			callKey: this.OdbcValue === 2 && item[SEARCH_OPTIONS.BY_CALL_KEY] ? item[SEARCH_OPTIONS.BY_CALL_KEY] : '',
			contactByODBC: true,
			dbSearchShowed: false,
			isSpinnerOn: false
		});
	}
	
	correctNumber() {
		this.setState({
			correctPhoneNumberShowed: false,
			phoneNumber: this.state.fixedPhoneNumber
		});
	}
	useNumber() {
		this.setState({
			correctPhoneNumberShowed: false,
			fixedPhoneNumber: ''
		});
	}
	incorrectNumber(message) {
		let callmode = this.sharedData.getGeneralPermissions()[206];
		let callCorrectionAutomatically = callmode === '2' || callmode === '1';

		let splited = message.Json.Message.split('|');
		let fixNumber = splited[1];
		if (!callCorrectionAutomatically) {
			this.step = STEP_MANUAL_CALL.INCORRECT_NUMBER;
			this.setState({
				fixedPhoneNumber: fixNumber,
				correctPhoneNumberShowed: true
			});
			let integrationMessage = { client: 'galatea', action: 'ManualCall', subaction: 'wrongNumber', data: fixNumber };
			SingletonWebSocket.send(integrationMessage);
		} else {
			this.setState({
				correctPhoneNumberShowed: false,
				phoneNumber: fixNumber
			});
			this.objectData.PhoneNumber = fixNumber;
			this.makeCall();
		}
	}
	blackListNumber(message) {
		this.setTimerCallAlert();
		const integrationMessage = { client: 'galatea', data: message, action: 'ManualCall', subaction: 'numberOnDoNotCallList' };
		SingletonWebSocket.send(integrationMessage);
	}
	handleErrors(messageError) {
		this.currentMessageError = messageError;
		Logger.Debug(`[Manual Call][handleErrors]currentMessageError =>  ${this.currentMessageError}`);
		if (messageError.Json) {
			Logger.Debug(`[Manual Call][handleErrors] MESSAGE ERROR  =>  ${messageError.Json.Type} => ${messageError.Json.Message}`);
			if (this.messagesCalatog[messageError.Json.Type] && this.messagesCalatog[messageError.Json.Type][messageError.Json.InternalCode]) {
				this.messagesCalatog[messageError.Json.Type][messageError.Json.InternalCode](messageError);
			}
		}
	}
	requestCall() {
		this.setState({ correctPhoneNumberShowed: false });
		if (!this.state.recievedAlert && this.canRequestCall) {
			this.blockRequestCall();
			if (this.validationsNumber[this.step]) {
				this.validationsNumber[this.step]();
			}
			this.lastNumberTried = this.state.phoneNumber;
			this.lastCampTried = this.state.campaingID;
			let callKey = this.state.currentState == 'ASSISTED' ? this.sharedData.dataObject.calKey : this.state.callKey;
			if (this.state.currentState == 'WRAPUP' && !this.state.callKey && this.sharedData.dataObject.calKey) {
				callKey = this.sharedData.dataObject.calKey;
			}
			this.objectData = {
				UserID: this.sharedData.getParameters().UserID,
				CampID: this.ManualCallAlwaysShow ? this.sharedData.getCampaingID() : this.state.campaingID,
				Ext: this.sharedData.getParameters().Extension,
				PhoneNumber: this.ManualCallAlwaysShow ? this.sharedData.getPhoneNumber() : this.state.phoneNumber,
				Name: this.state.data1,
				CallOutChange: 0,
				Status: this.step,
				CallKey: callKey,
				CallMode: 0
			};
			this.validatePhoneNumber(this.objectData);
		}
		this.setState({ shortNumber: false });
	}
	validatePhoneNumber(objectData) {
		let objectResponse = this.apiCont.getObjectResponse();
		this.props.consultingApp();
		this.apiCont.validatePhoneNumber(objectData, objectResponse);
		var _this = this;
		objectResponse.onError = function (messageError) {
			Logger.Debug(`[Manual Call][validatePhoneNumber] validatePhoneNumber Api Controller ERROR  =>  ${messageError}`);
			_this.handleErrors(messageError);
			_this.props.noConsultingApp();
		};
		objectResponse.onSuccess = function () {
			_this.props.noConsultingApp();
			_this.makeCall();
		};
	}

	makeCall() {
		let _this = this;

		if (_this.state.contactByODBC && this.OdbcValue === 2) {
			_this.sharedData.setOdbcExternalCall(true);
			_this.setState({ dbSearchShowed: true });
		} else {
			_this.sharedData.setOdbcExternalCall(false);
		}

		var data = {
			CamId: this.objectData.CampID,
			CallKey: this.objectData.CallKey,
			Phone: this.objectData.PhoneNumber,
			Data: this.objectData.Name,
			ExistsCallout: 0,
			CallMode: 0,
			integration: _this.integration,
			Odbc: _this.state.contactByODBC && _this.OdbcValue > 0 ? 1 : 0,
			ani: this.state.aniSelected
		};
		_this.setState({ contactByODBC: false, callKey: '' });
		_this.sharedData.setPhoneNumber(this.objectData.PhoneNumber);
		_this.props.manualCall(data);
		_this.keyboard.blurTel();
	}

	closeAlert(e) {
		this.setState({ recievedAlert: e });
	}

	searchOnDataBase() {
		switch (this.OdbcValue) {
			case 0:
				this.setState({ dbSearchShowed: false, externalDBNotConfiguredShowed: true });
				this.startTimeOut();
				break;
			case 1:
				this.getExternalContacts();
				break;
			case 2:
				if (this.state.campaingID === 0) {
					this.setState({ dbSearchShowed: false, noCampaignSelected: true });
					this.startTimeOut();
				} else {
					this.getExternalOdbcCampaign(this.state.campaingID);
				}
				break;
			default:
				break;
		}
	}

	startTimeOut() {
		setTimeout(() => {
			this.accept();
		}, 5000);
	}

	getExternalContacts() {
		let objectResponse = this.apiCont.getObjectResponse();
		this.props.consultingApp();
		this.apiCont.externalContacts(objectResponse);
		let _this = this;
		objectResponse.onError = function (messageError) {
			Logger.Debug(`[Manual Call][getExternalContacts] ApiController ERROR  =>  ${messageError}`);
			_this.props.noConsultingApp();
			_this.setState({ dbSearchShowed: false, externalDBNotConfiguredShowed: true });
			_this.startTimeOut();
		};
		objectResponse.onSuccess = function (objResponse) {
			_this.props.noConsultingApp();
			_this.setState({ contactList: objResponse });
			_this.setState({ dbSearchShowed: true, externalDBNotConfiguredShowed: false });
		};
	}

	getExternalOdbcCampaign(campId) {
		let objectResponse = this.apiCont.getObjectResponse();

		let _this = this;
		_this.setState({ isSpinnerOn: true });
		this.apiCont.externalOdbcCampaign(campId, objectResponse);
		objectResponse.onError = function (messageError) {
			Logger.Debug(`[Manual Call][getExternalOdbcCampaign] ApiController ERROR  =>  ${messageError}`);

			let messageSplited = messageError.split('-');

			_this.setState({ isSpinnerOn: false, odbcMessageError: true });

			messageSplited.length === 1 ? _this.setState({ messageError: messageSplited[0] }) : _this.setState({ messageError: messageSplited[1] });

			messageSplited.length > 1 && messageSplited[1] === '7' ? _this.setState({ dbSearchShowed: true, contactList: [] }) : null;

			_this.startTimeOut();
		};
		objectResponse.onCatch = function (messageError) {
			console.warn(messageError);
			_this.setState({ isSpinnerOn: false });
			_this.props.showAlertModal(alertQueryErrorBody());
		};
		objectResponse.onSuccess = function (objResponse) {
			_this.setState({ isSpinnerOn: false });
			_this.setState({ contactList: objResponse, dbSearchShowed: true, externalDBNotConfiguredShowed: false });
		};
	}

	accept() {
		this.setState({ externalDBNotConfiguredShowed: false });
		this.setState({ InvalidCampaingAlert: false });
		this.setState({ odbcMessageError: false });
		this.setState({ searchEmpty: false });
		this.setState({ noCampaignSelected: false });
		this.setState({ showNoInputMessage: false });
		this.setState({ noANIListSelected: false,loadAni:false });
	}

	blockRequestCall() {
		this.canRequestCall = false;
		setTimeout(() => {
			this.canRequestCall = true;
		}, 3000);
	}
	userHangedout() {
		this.userHangout = true;
	}
	onAlertRecieved() {
		if (this.state.recievedAlert) {
			if (this.userHangout) {
				this.setState({ recievedAlert: false });
				this.userHangout = false;
				this.setState({ userHangout: false });
				return false;
			} else {
				return true;
			}
		} else {
			return false;
		}
	}
	playStopAudio(audio, time) {
		if (audio === null) {
			return false;
		}
		if (time > 0) {
			audio.play();
		}
		setTimeout(() => {
			audio.pause();
		}, time);
	}

	setFilterTypeHandler(item) {
		if (this.OdbcValue === 2) {
			if (item.searchingBy === 'callKey') {
				this.customCell = CUSTOM_CELLS.BY_CALL_KEY;
				this.searchOdbcOptions = this.searchOdbcOptions[0].searchingBy === 'callKey' ? this.searchOdbcOptions : [this.searchOdbcOptions[2], this.searchOdbcOptions[0], this.searchOdbcOptions[1]];
			} else if (item.searchingBy === 'name') {
				this.customCell = CUSTOM_CELLS.BY_NAME;
				this.searchOdbcOptions = this.searchOdbcOptions[0].searchingBy === 'name' ? this.searchOdbcOptions : [this.searchOdbcOptions[1], this.searchOdbcOptions[2], this.searchOdbcOptions[0]];
			}
		}
		this.setState({ currentSearch: item });
	}

	validateFilter(e) {
		this.setState({ searchDataBase: e });

		if (e === '') {
			this.setState({ searchEmpty: false });
		}

		const searchBy = this.state.currentSearch.searchingBy;
		const contacts = this.state.contactList;
		let result = 0;

		contacts.map(item => {
			if (item[searchBy].toLowerCase().indexOf(e.toLowerCase()) >= 0) {
				result = 1;
			}
		});

		if (result === 0) {
			this.setState({ searchEmpty: true });
			this.startTimeOut();
		}
	}
	makeManualCall() {
		if (this.state.data1 === '' && this.state.campaingManualMode === 3 || (this.sharedData.generalPermissions[115]==="1" && this.state.data1==="")) {
			this.setState({ showNoInputMessage: true });
		} else {
			this.setState({ showNoInputMessage: false });
			this.integration = false;
			this.requestCall();
		}
	}
	onSelectANIListShowed() {
		this.setState({ ANIListShowed: !this.state.ANIListShowed });
		if (!this.state.ANIListShowed && this.sharedData.isANIListEmpty) {
			this.setState({ noANIListSelected: this.sharedData.isANIListEmpty });
			this.startTimeOut();
		}
	}
	rendeTableANI(){
		return this.state.aniList
			.filter(i => i.includes(this.state.searchANI))
			.sort((a, b) => (this.state.aniOrder ? b - a : a - b))
			.map((v, i) => (
				<SingleTable
					data={v}
					key={i}
					onSelectANI={ani =>
						this.setState({
							ANIListShowed: false,
							aniSelected: ani
						})
					}
				/>
			))
	}

	handleKeyUp = (event) => {
		if (event.key === 'Enter') {
			if(!event.shiftKey && this.state.campaingSelected && this.state.messageToSend.replace(/\n+$/, "").trim().length > 0)
			{
				this.validateWhatsAppPhoneNumber();
			}
		}
	}

	validateData = (inputType) => {
		if(this.state.isManualMessage){
			switch(inputType){
				case MANUAL_INPUTS.PHONE_NUMBER:
					return this.state.phoneNumber === '' || this.state.phoneNumber.length < 12;
				case MANUAL_INPUTS.MESSAGE_AREA:
					return !this.state.campaingSelected || this.state.messageToSend.replace(/\n+$/, "").trim().length < 1;
			}
		}else{
			return !this.state.campaingSelected || this.state.phoneNumber === '';
		}
	}

	validateDataPhone = () => {
		const disabled = this.state.phoneNumber === '' || this.state.phoneNumber.length < 12;
		if(disabled){
			this.setState({
				phoneNumberNoValid: true, writeMessage: false
			})
			setTimeout(() => {
				this.setState({phoneNumberNoValid: false})
			},	5000)
		}else{
			this.setState({
				showPhoneNumber: true,
				writeMessage: true,
				step: 1
			})
		}
	}

	setTemplateWhatsApp = (template) => {
		this.setState({ templateWhatsapp: template, step: 2 });
	}

	getOutboundWhatsAppTemplates(props = null, closedIfOpen = true){
		let _this = this;
		var dataToSend = {
			UserID: _this.sharedData.getParameters().UserID,
			CampID: _this.state.campaingID,
			PhoneNumber: _this.state.phoneNumber
		};

		let objectResponse = this.apiCont.getObjectResponse();
		this.apiCont.getWhatsAppTemplates(dataToSend, objectResponse);
		objectResponse.onError = function (messageError) {
			Logger.Debug(`[Manual Call][templatesWhatsapp] templatesWhatsapp Api Controller ERROR  =>  ${messageError}`);
			_this.handleErrors(messageError);
		};
		objectResponse.onSuccess = function (data) {
			const templatesList = _.get(data, 'Json.Response');
			_this.props.insertWindow(templatesWhatsappWindow({templatesList: templatesList}, _this.setTemplateWhatsApp), closedIfOpen);
		};
	}

	validateWhatsAppPhoneNumber() {
		let _this = this;
		var dataToSend = {
			UserID: _this.sharedData.getParameters().UserID,
			CampID: _this.state.campaingID,
			PhoneNumber: _this.state.phoneNumber
		};

		let objectResponse = this.apiCont.getObjectResponse();
		_this.props.onSetMessageStatus(MANUAL_MESSAGES_STATUS.SENDING, this.state.phoneNumber);
		this.apiCont.validateWhatsAppPhoneNumber(dataToSend, objectResponse);
		objectResponse.onError = function (messageError) {
			Logger.Debug(`[Manual Call][validateWhatsAppPhoneNumber] validateWhatsAppPhoneNumber Api Controller ERROR  =>  ${messageError}`);
			_this.handleErrors(messageError);
		};
		objectResponse.onSuccess = function (data) {
			const conversationId = _.get(data, 'Json.Response.ConversationId');
			const camDescription = _.get(data, 'Json.Response.CamDescription');
			const requestDate = _.get(data, 'Json.Response.RequestDate');
			const userId = _.get(data, 'Json.Response.UserId');
			const username = _.get(data, 'Json.Response.Username');
			let date = new Date(requestDate); 
			let localeString = ['en-GB','en-US','en-GB']
			let localeStringOptions = ['2-digit','numeric', 'numeric'];
			let formatDate = `${date.toLocaleDateString(localeString[_this.lang], { day: "numeric", month: "numeric",year: localeStringOptions[_this.lang], timeZone: 'UTC' })}`;
			let formatTime = `${date.toLocaleTimeString(localeString[_this.lang], { hour: "2-digit", minute: "2-digit", })}`;
			if(conversationId && conversationId !== 0){
				_this.props.onSetMessageConvId(conversationId);
				_this.sendManualMessage({
					...dataToSend,
					conversationId
				})
			}else{
				if(camDescription !== null){
					_this.conversationWAInavailable(userId, username, camDescription, formatDate, formatTime);
				}
				setTimeout(() => {
					_this.props.onSetMessageStatus(MANUAL_MESSAGES_STATUS.NETWORK_ERROR, _this.state.phoneNumber);
				}, 300)
			}
		};
	}

	conversationWAInavailable = (userId, username, camDescription, date, time) => {
		let message = this.availableWAConnections[this.objectData.UserID !== userId ? 0 : 1];
		const formatDate = ['[dd/mm/aa]', '[mm/dd/yyyy]', '[dd/mm/aaaa]'];
		if(this.objectData.UserID !== userId){
			message = message.replace('[N]', username);
			message = message.replace('[N]', camDescription);
			message = message.replace(formatDate[this.lang] , date);
			message = message.replace('[hh:mm]', time);
		}else{
			message = message.replace('[N]', camDescription);
			message = message.replace(formatDate[this.lang], date);
			message = message.replace('[hh:mm]', time);
		}

		this.props.showAlertModal({
			type: "ModalAlert",
			title: "CenterWare Kolob",
			message: message,
			button: this.language.getText('GUIErrorMessageclose'),
			buttonFun: () => {  }
		});
	}

	sendManualMessage = (dataToSend) => {
		let _this = this;
		var data = {
			UserID: dataToSend.UserID,
			ConversationId: dataToSend.conversationId,
			messageId: 0,
			AcdId: dataToSend.CampID,
			CamType: 1,
			Phone: _this.state.phoneNumber,
			MessageText: `${_this.state.templateWhatsapp.TemplateName}`,
			MessageType: "template",
			MediaType: MEDIATYPE.WHATSAPP,
			ConvUiId: `${_this.state.campaingID}|${1}|${_this.state.phoneNumber}`,
		};

		_this.props.onSendManualMessage(data);
	}

	closeManualMessageAlert = () => {
		this.props.onSetMessageStatus(MANUAL_MESSAGES_STATUS.SEND, this.props.manualMessagePhone);
	}
	
	render() {
		let user_CallOut = this.state.currentState === USER_STATE.CALL_OUT;
		let recievedAlert = this.state.recievedAlert;
		return (
			<div className='manualCall' onClick={() => this.props.goTopZ(this.props.id)}>
				{CUSTOM_COMPONENTS['draggableHeader'](
					this.state.isManualMessage ? <img src={whatsappIcon} width={16} height={16} /> : manualCallSvg,
					this.language.getText(this.state.isManualMessage ? 'GUIManualMessagemanual-msg-tool' : 'GUICommonMenumanualCall'),
					!user_CallOut
						? () => {
								this.props.removeWindow(this.state.isManualMessage ? DRAGGABLE_WINDOWS.MANUAL_MESSAGE : DRAGGABLE_WINDOWS.MANUAL_CALL);
						  }
						: null,
					{
						iconHeader: this.state.isManualMessage ? 'iconWhatsHeader' : ''
					}
				)}
				{user_CallOut && !this.state.isManualMessage && (
					<CallOutContainer
						time={this.sharedData.getManualCallTime()}
						phone={this.sharedData.phoneNumber !== this.state.phoneNumber ? this.sharedData.phoneNumber : this.state.phoneNumber}
						userHangedout={() => this.userHangedout()}
					/>
				)}
				<div className={'visibleWindow ' + (user_CallOut || recievedAlert || (this.state.isManualMessage && this.props.manualMessageStatus) ? 'blur ' : '') + (this.state.step === 1 ? 'step-1':'')}>
					<div className={`selectCampaing ${this.state.campaingSelected ? 'campSelected' : ''}`} onClick={() => this.setState({ campaingsShowed: !this.state.campaingsShowed })}>
						{!(this.state.campaingSelected === '') && <img className='iconCampaingSelected' src={outBoundCall} alt='outBoundCall' />}
						{!(this.state.campaingSelected === '') && <img className='iconCampaingSelected iconCampaingSelectedPadding' src={this.state.campaingImage} alt=' ' />}
						<p className={`campaingSelected ${this.state.campaingSelected ? 'campSelected' : ''}`}>
							{this.state.campaingSelected === '' ? this.language.getText(this.state.isManualMessage ? 'GUIManualMessageselect-campaign' : 'GUIManualCallselect') : this.state.campaingSelected}
						</p>
						<div className={'arrowSelectCampaing ' + (this.state.campaingsShowed ? 'rotated' : 'normal')}> {arrowBack} </div>
					</div>
					{
						!this.state.campaingsShowed && this.state.showPhoneNumber && this.state.isManualMessage && this.state.phoneNumber && this.state.writeMessage ?
						<div className={`manualMessageDetailPhoneArea ${this.state.showPhoneNumber ? 'campSelected' : ''}`} onClick={() => this.setState({ writeMessage: false, step: 0 })}>
							<div className='manualMessageDetailPhoneIcon'>{cellICon}</div>
							<div className='manualMessageDetailPhone'>{this.state.phoneNumber}</div>
						</div>
						:
						null
					}
					{(this.state.rotativeAniManualCall === 1 && !this.state.isManualMessage) && (
						<div className={`selectAni ${this.state.ANIListShowed ? 'showed' : ''}`} onClick={() => this.onSelectANIListShowed()}>
							<p className={`aniSelected ${this.state.aniSelected ? 'aniSelectedA' : ''}`}>
								{this.state.aniSelected === '' ? this.language.getText('GUIManualCallselectANI') : this.state.aniSelected}
							</p>
							<div className={'arrowANISelected ' + (this.state.ANIListShowed ? 'rotated' : 'normal')}> {arrowBack} </div>
						</div>
					)}
					<div className={`optionsManualCall ${this.state.isSpinnerOn ? 'spinnerOn' : ''} ${this.state.step === 2 ? 'step-2':''}`}>
						<div className='dataBaseSearch activeSearch' onClick={() => this.searchOnDataBase()}>
							<img className='iconDataBaseSearch' src={search} alt='search'></img>
							<p className='infoDataBaseSearch text'>{this.language.getText(this.state.isManualMessage ? 'GUIManualMessagesearch-box' : 'GUIManualCallsearchInDataBase')}</p>
						</div>
						{this.state.isSpinnerOn ? (
							<div>
								<div className='spinnerDatabaseSearch'><div className='manualMessageDetailPhoneIcon'>{cellICon}</div>
							<div className='manualMessageDetailPhone'>{this.state.phoneNumber}</div>
									<Spinner color='primary' style={{ width: '2rem', height: '2rem' }} />
								</div>
								<div className='spinnerDatabaseSearchText'>
									<p>{this.language.getText('GUILoginloading')}</p>
								</div>
							</div>
						) : (
							<div>
								{
									this.state.step === 0 && (
									<div className={this.state.writeMessage ? 'infoWriteMessage' : 'dataManualCall'}>
									{
										!this.state.isManualMessage ?
											<div>
												<p className='divContainerSeparator textLeft'>{'1'}</p>
												<input
													type='text'
													placeholder={this.language.getText('GUIManualCalldata1')}
													className='txtDataClientCellMC'
													value={this.state.data1}
													onChange={event => {
														this.setState({ data1: event.target.value, });
														event.target.value!=="" && this.setState({showNoInputMessage:false})
													}}
												/>
											</div>
										:
										null
									}
									{/* {
										this.state.writeMessage ?
										<div className='infoWriteMessageHelp'>
											{this.language.getText('GUIManualMessagestandards-rmd')}
										</div>
										:
										null
									} */}
									</div>)
								}
								<div className={`manualCallNumber ${this.state.writeMessage ? 'manualCallNumberWrite' : ''}`}id='manualCallNumber'>
									{
										this.state.writeMessage ?
										<div className='manualMessage'>
											<div className='manualMessageArea'>
											{this.state.step === 1 ? (
													<div className={`manualMessageButton ${this.state.campaingID === 0 ? 'disabled':''}`} onClick={() => this.getOutboundWhatsAppTemplates()}>
														<div className='manualMessageIconList'>{iconList}</div>
														<div className='manualMessageTitleText'>
															{this.language.getText('GUIManualMessageselect-template')}
														</div>
													</div>
												) : this.state.step === 2 ? (
													<div className='ManualMessageTextArea'>
														<TextareaAutosize id='txtManualMessage' className={'manualMessageAreaText'} value={this.state.templateWhatsapp.Body} innerRef={ref => (this.textArea = ref)} />
														<hr className='manualMessageLine' />
														<div className='manualMessageLength'>
															<div className={`manualMessageLengthSend`} onClick={() => this.validateWhatsAppPhoneNumber()}>
																<img src={sendMessageIcon} className='manualMessageLengthSendIcon' />
															</div>
														</div>
													</div>
												) : null}
												{/* <TextareaAutosize
													id="txtManualMessage"
													className={"manualMessageAreaText"}
													maxLength={MAX_LENGTH_MESSAGE}
													placeholder={this.language.getText('GUIManualMessageplaceholder')}
													onChange={event => this.setState({messageToSend: event.target.value})}
													value={this.state.messageToSend}
													onKeyUp={event => this.handleKeyUp(event)}
													innerRef={ref => this.textArea = ref}
													/>
												<hr className='manualMessageLine' />
												<div className='manualMessageLength'>
													{`${this.state.messageToSend.length} / ${MAX_LENGTH_MESSAGE}`}
													<div className={`manualMessageLengthSend ${this.validateData(MANUAL_INPUTS.MESSAGE_AREA) ? 'disabled' : ''}`} onClick={() => this.validateWhatsAppPhoneNumber()}>
														<img src={sendMessageIcon} className='manualMessageLengthSendIcon' />
													</div>
												</div> */}
											</div>
										</div>
										:
										<div>
											<Keyboard
											ref='Keyboard'
											number={this.state.phoneNumber}
											onChangeNumber={number => this.setState({ shortNumber: false, phoneNumber: number })}
											onEnter={() => {
												if(this.state.isManualMessage){
													this.makeManualCall()
												}else{
													this.state.campaingSelected ? this.requestCall() : null
												}
											}}
											onClean={() => this.setState({ phoneNumber: '' })}
											onFocus={this.sharedData.getFocusTel()}
											disabled={this.state.disableManualCall}
											isManualMessage={this.state.isManualMessage}
											infoTooltip={this.state.isManualMessage && `${this.language.getText('GUIManualMessagetooltip-one')}\n${this.language.getText('GUIManualMessagetooltip-two')}`}
											/>
											<div
												className={'makeManualCall ' + (this.validateData(MANUAL_INPUTS.PHONE_NUMBER) ? 'disabled' : '')}
												onClick={this.state.isManualMessage ? () => this.validateDataPhone() : () => this.makeManualCall()}>
													{
														this.state.isManualMessage ? 
														<img src={whatsappIcon} />
														:
														phoneIcon
													}
											</div>
										</div>
									}
								</div>
							</div>
						)}
					</div>
				</div>
				<div className={'listCampaings ' + (this.state.campaingsShowed ? 'showedLC' : 'hiddenLC')}>
					{CUSTOM_COMPONENTS['inputDelete'](
						this.state.searchCampaing,
						e => {
							this.setState({ searchCampaing: e });
						},
						'dataBaseSearch smallDBSearch',
						'infoDataBaseSearch',
						'manualCallCleanButton',
						btnClear,
						false,
						search,
						'iconDataBaseSearch',
						this.language.getText('CallControlCRMxcontrolssearchForMatchesButton')
					)}
					<div className='btnOrder' onClick={() => this.setState({ campaingOrder: !this.state.campaingOrder })}>
						{this.state.campaingOrder ? ZtoA : AtoZ}
					</div>
					<div className='campaingList'>
						<TableComponent
							customCell={'cellCampaings'}
							parameters={{ name: 'Description', imgCampaing: 'imgCampaing', isFav: 'isFav', starFav: 'starFav' }}
							dataSource={this.state.campaingList}
							orderBy={'Description'}
							orderForm={this.state.campaingOrder}
							searching={this.state.searchCampaing}
							searchingValue={'Description'}
							onSelectItem={item => this.selectCampaing(item)}
							onActionInCell={(e, item) => this.favCampaing(e, item)}
						/>
					</div>
				</div>
				{this.state.rotativeAniManualCall === 1 && (
					<div className={'listANIs ' + (this.state.ANIListShowed ? 'showedLC' : 'hiddenLC')}>
						{CUSTOM_COMPONENTS['inputDelete'](
							this.state.searchANI,
							e => {
								this.setState({ searchANI: e });
							},
							'dataBaseSearch smallDBSearch',
							'infoDataBaseSearch',
							'manualCallCleanButton',
							btnClear,
							false,
							search,
							'iconDataBaseSearch',
							this.language.getText('CallControlCRMxcontrolssearchForMatchesButton')
						)}
						<div className='btnOrder' onClick={() => this.setState({ aniOrder: !this.state.aniOrder })}>
							{this.state.aniOrder ? ZtoA : AtoZ}
						</div>
						<div className='aniList'>
							{this.state.loadAni && !this.state.noANIListSelected ? (
								<div>
									<div className='spinnerDatabaseSearch'>
										<Spinner color='primary' style={{ width: '2rem', height: '2rem' }} />
									</div>
									<div className='spinnerDatabaseSearchText'>
										<p>{this.language.getText('GUILoginloading')}</p>
									</div>
								</div>
							) : (this.rendeTableANI())}
						</div>
					</div>
				)}
				<div className={'dataBaseSearchContainer ' + (this.state.dbSearchShowed ? 'dbSearchShowed' : 'dbSearchHidden')} onClick={() => this.setState({ dbSearchOptions: false })}>
					<div className='dataBaseSearchHeader'>
						<div className='dataBaseSearchHeader-up'>
							<div className='backDataBaseSearch' onClick={() => this.setState({ dbSearchShowed: false })}>
								{arrowBack}
							</div>
							{CUSTOM_COMPONENTS['inputDelete'](
								this.state.searchDataBase,
								e => this.validateFilter(e),
								'dataBaseSearch smallDBSearch',
								'infoDataBaseSearch',
								'manualCallCleanButton',
								btnClear,
								false,
								search,
								'iconDataBaseSearch',
								this.language.getText('CallControlCRMxcontrolssearchForMatchesButton')
							)}
						</div>
						<div className='dataBaseSearchHeader-down'>
							<p className='searchText'>{this.language.getText('GUIManualCallsearchBy')}</p>
							<div className='searchOptionSelection'>
								<SelectComponent
									itemDefault={0}
									displayer={'displayBlack'}
									parameters={{ text: 'text' }}
									customCell={'cellText'}
									styleContainer={'selectSearch'}
									dataSource={this.OdbcValue === 1 ? this.searchOptions : this.searchOdbcOptions}
									onSelectItem={item => this.setFilterTypeHandler(item)}
								/>
							</div>
						</div>
					</div>

					<div className='manualCallDataContainers'>
						<div className='manualCallDataCell'>
							{this.OdbcValue === 1
								? this.searchOptions.map(item => (
										<p key={item.text} className='manualCallCell title'>
											{item.text}
										</p>
								  ))
								: this.searchOdbcOptions.map(item => (
										<p key={item.text} className='manualCallCell title'>
											{item.text}
										</p>
								  ))}
						</div>
						<div className='directoryTableContainer'>
							<TableComponent
								customCell={this.customCell}
								parameters={this.OdbcValue === 1 ? this.externalParameters : this.externalOdbcParameters}
								dataSource={this.state.contactList}
								searching={this.state.searchDataBase}
								searchingValue={this.state.currentSearch.searchingBy}
								onSelectItem={item => this.selectContact(item)}
							/>
						</div>
					</div>
				</div>
				{this.state.correctPhoneNumberShowed && (
					<div className='alertContainer'>
						<AlertWindow
							title={this.language.getText('GUIManualCallautocorrectTitle')}
							btnNo={this.language.getText('GUIManualCalldoNotCorrect')}
							btnYes={this.language.getText('GUIManualCallcorrect')}
							body={correctPhoneNumber(this.language.getText('alert-1092'), this.state.fixedPhoneNumber)}
							onYes={() => this.correctNumber()}
							onNo={() => this.useNumber()}
							isGlobe={true}
						/>
					</div>
				)}
				{this.state.externalDBNotConfiguredShowed && (
					<div className='alertExternalDB' onMouseDown={() => this.accept()}>
						<AlertWindow title={this.language.getText('GUIManualCallconfiguration')} body={generalBody(this.language.getText('alert-1098'))} isGlobe={true} />
					</div>
				)}
				{this.state.odbcMessageError && (
					<div className='alertExternalDB' onMouseDown={() => this.accept()}>
						<AlertWindow
							title={this.language.getText('GUIManualCallNoDataTitle')}
							body={generalBody(this.state.messageError.length > 1 ? this.language.getText('GUIAlertTransferunexpectedError') : this.language.getText('alert-110' + this.state.messageError))}
							isGlobe={true}
						/>
					</div>
				)}
				{this.state.noCampaignSelected && (
					<div className='alertExternalDB' onMouseDown={() => this.accept()}>
						<AlertWindow title={this.language.getText('GUIManualCallconfiguration')} body={generalBody(this.language.getText('GUIManualCallNoCampaignSelected'))} isGlobe={true} />
					</div>
				)}
				{this.state.noANIListSelected && (
					<div className='alertExternalDB' onMouseDown={() => this.accept()}>
						<AlertWindow title={this.language.getText('GUIManualCallconfiguration')} body={generalBody(this.language.getText('GUIManualCallNoANIAvailable'))} isGlobe={true} />
					</div>
				)}
				{this.state.searchEmpty && this.state.searchDataBase !== '' && (
					<div className='alertExternalDB' onMouseDown={() => this.accept()}>
						<AlertWindow title={this.language.getText('GUIManualCallNoDataTitle')} body={generalBody(this.language.getText('alert-1107'))} isGlobe={true} />
					</div>
				)}
				{this.state.shortNumber && (
					<div className='alertContainer'>
						<AlertWindow
							title={this.language.getText('GUIManualCallmanualCall')}
							body={generalBody(this.language.getText('alert-1091'))}
							btnYes={this.language.getText('GUIErrorMessageclose')}
							isGlobe={true}
							isInfo={true}
						/>
					</div>
				)}
				{this.state.InvalidCampaingAlert && (
					<div className='alertContainer'>
						<AlertWindow
							title={this.language.getText('GUIManualCallmanualCall')}
							body={generalBody(this.language.getText('error-1099'))}
							btnYes={this.language.getText('GUIErrorMessageclose')}
							isGlobe={true}
							isInfo={true}
							onYes={() => this.accept()}
						/>
					</div>
				)}
				{this.state.NoCampaignsFoundAlert && (
					<div className='alertNoCampaignsFound'>
						<AlertWindow title={this.language.getText('GUIManualCallconfiguration')} body={generalBody(this.language.getText('error-1083'))} isGlobe={true} isInfo={true} />
					</div>
				)}
				{this.state.CallValidationAlert && (
					<div className='alertContainer'>
						<AlertWindow
							title={this.language.getText('GUIManualCallmanualCall')}
							body={generalBody(this.language.getText(this.currentMessageError.Json.Type.toLowerCase() + '-' + this.currentMessageError.Json.InternalCode))}
							btnYes={this.language.getText('GUIErrorMessageclose')}
							isGlobe={true}
							isInfo={true}
						/>
					</div>
				)}
				{this.onAlertRecieved() && (
					<AlertManualCallWindow
						playStopAudio={this.playStopAudio}
						phoneNumber={this.sharedData.phoneNumber !== this.state.phoneNumber ? this.sharedData.phoneNumber : this.state.phoneNumber}
						alertCode={this.state.alertCode}
						closeAlert={e => this.closeAlert(e)}
						closeManualCall={this.closeManualCall}
						message={this.state.message}
					/>
				)}
				{this.state.isManualMessage && this.props.manualMessageStatus && (
					<AlertManualMessageWindow
						phoneNumber={this.state.phoneNumber}
						alertCode={this.props.manualMessageStatus === MANUAL_MESSAGES_STATUS.SENDING ? 'CUSTOM' : MANUAL_MESSAGES_STATUS_TAG[this.props.manualMessageStatus]}
						closeAlert={e => this.closeManualMessageAlert(e)}
						message={this.language.getText('GUIManualMessagesend-animation')}
					/>
				)}
				{(this.state.showNoInputMessage &&
				<div className='alertContainerNoInputMessage'>
					<AlertWindow
						title={this.language.getText('GUIManualCallmanualCall')}
				 		body={generalBody(this.language.getText('GUIManualCallNoInputMsg'))}
						btnYes={this.language.getText('GUIErrorMessageclose')}
				 		isGlobe={true}
				 		isInfo={true}
					/> 
				</div>
				)}
				{(
					this.state.phoneNumberNoValid && 
					<div className='alertContainer'>
						<AlertWindow
							title={this.language.getText('GUIManualMessageinvalid-error-title')}
							body={generalBody(this.language.getText('GUIManualMessageinvalid-error-msg'))}
							isGlobe={true}
							isInfo={true}
						/>
					</div>
				)}
			</div>
		);
	}
}
function mapStateToProps(state) {
	return {
		dragWindowController: state.dragWindowController,
		otherActions: state.otherActions,
		userState: state.userState,
		messagesIntegrations: state.messagesIntegrations,
		manualMessageStatus: state.manualMessageReducer.manualMessageStatus,
		prevManualMessageStatus: state.manualMessageReducer.prevManualMessageStatus,
		manualMessageConvId: state.manualMessageReducer.convId,
		manualMessagePhone: state.manualMessageReducer.phone
	};
}
function mapDispatchToProps(dispatch) {
	const { showAlertModal } = AlertModalActions.creators;
	return {
		insertWindow: (dragWindow, closeComponentIfOpen) => {
			dispatch(insertWindow(dragWindow, closeComponentIfOpen));
		},
		removeWindow: iDdragComponent => {
			dispatch(removeWindow(iDdragComponent));
		},
		manualCall: data => {
			dispatch(manualCall(data));
		},
		messageApiRequest: (subaction, json, expectsReponse) => {
			dispatch(messageApiRequest(subaction, json, expectsReponse));
		},
		consultingApp: () => {
			dispatch(consultingApp());
		},
		noConsultingApp: () => {
			dispatch(noConsultingApp());
		},
		changeIsIntegration: () => {
			dispatch(changeIsIntegration());
		},
		showAlertModal: payload => {
			dispatch(showAlertModal(payload));
		},
		onSendManualMessage: data =>{
			dispatch(onSendUnifiedResponse(data))
		},
		onSetMessageStatus: (messageStatus, phone) => {
			dispatch(setMessageStatus(messageStatus, phone))
		},
		onSetMessageConvId: (convId) => {
			dispatch(setMessageConvId(convId))
		},
		messageApiRequestANIList: (subaction, camId, expectsReponse) => {
			dispatch(messageApiRequestANIList(subaction, camId, expectsReponse));
		},
		getRecordCallPermission: (subaction, camId, expectsReponse) => {
			dispatch(getRecordCallPermission(subaction, camId, expectsReponse));
		},
	};
}
export default ManualCall = connect(mapStateToProps, mapDispatchToProps)(ManualCall);



// WEBPACK FOOTER //
// ./src/components/workSpace/floatingWindows/ManualCall.jsx